﻿import moment from 'moment';
import template from 'lodash.template';

import findAncestorWithAttr from '../Utils/findAncestorWithAttr';
import validateInput from '../Utils/validateInput';

import LfDataService from '../Services/LfDataService';
import LfWebService from '../Services/LfWebService';

import LifeRecommendationQuoteHandler from './LifeRecommendationQuoteHandler';

export default class QuickInsuranceQuoteHandler {
    constructor() {
        this.lfDataService = new LfDataService();
        this.lfWebService = new LfWebService();

        this.resultTemplateId = 'quote-result__template';
        this.resultTemplate = null;
        this.errorTemplateId = 'quote-error__template';
        this.errorTemplate = null;

        this.resultContainerSl = '.quick-insurance-quote-block__result';

        this.buttonSl = '.quick-insurance-quote-form__button';
        this.ageInputSl = '.quick-insurance-quote-form__input__age';

        this.loaderSl = '.loader';
        this.loaderActiveCl = 'loader--active';

        this.accordionBodyAttr = 'data-lf-accordion-body';

        this.loadStartTimeStamp = null;
        this.initialize();
    }

    getSibling = (el, sl) => el.parentElement.querySelector(sl);

    initialize() {
        let templateEl = document.getElementById(this.resultTemplateId);
        let errorTemplateEl = document.getElementById(this.errorTemplateId);
        if (!templateEl || !errorTemplateEl) { // shouldn't init
            return;
        }

        this.resultTemplate = template(templateEl.innerHTML);
        this.errorTemplate = template(errorTemplateEl.innerHTML);

        this.resultContainer = document.querySelector(this.resultContainerSl);

        this.setupEventListeners();
    }

    showLoader = () => {
        let loaderEl = document.querySelector(this.loaderSl);
        loaderEl.classList.add(this.loaderActiveCl);

        this.loadStartTimeStamp = Date.now();
    }

    waitForLoader = (data) => {
        return new Promise(resolve => {
            setTimeout(() => {
                let loaderEl = document.querySelector(this.loaderSl);
                loaderEl.classList.remove(this.loaderActiveCl);

                resolve(data);
            }, 500 - (Date.now() - this.loadStartTimeStamp));
        });
    }

    inputsValid = (ageEl) => {
        const isNumber = val => typeof val !== 'undefined' && val !== '' && !isNaN(parseInt(val));
        let allValid = true;

        if (!validateInput(val => isNumber(val) && val < 150, ageEl)) {
            allValid = false;
        }

        return allValid;
    }

    setupEventListeners = () => {
        let formEls = document.querySelectorAll(this.buttonSl);

        if (formEls.length == 0)
            return;

        let accordionBody = findAncestorWithAttr(formEls[0], this.accordionBodyAttr);

        const insuranceGroup = accordionBody.dataset.lfInsuranceName;

        formEls.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                this.resultContainer.innerHTML = '';

                let ageEl = this.getSibling(button.parentElement, this.ageInputSl);
                let age = ageEl.value;
                let dob = moment().subtract(age, 'years').format('YYYY-MM-DD');

                if (!this.inputsValid(ageEl)) {
                    return;
                }

                this.showLoader();
                this.lfDataService.quickInsuranceQuote(insuranceGroup, dob)
                    .then(result => this.waitForLoader(result))
                    .then(result => {
                        let purchaseBaseUrl =
                            this.lfWebService.insurancePurchaseUrl(insuranceGroup, '{insuranceName}', null, null);

                        let resultHtml = this.resultTemplate({
                            quotes: result,
                            purchaseBaseUrl,
                            insuranceGroup
                        });

                        // let accordionBody = findAncestorWithAttr(this.resultContainer, this.accordionBodyAttr);
                        this.resultContainer.innerHTML = resultHtml;
                        accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';

                        setTimeout(() => {
                            new LifeRecommendationQuoteHandler({
                                quotes: result,
                                purchaseBaseUrl,
                                insuranceGroup
                            });
                        }, 100);
                    })
                    .catch(error => {
                        console.warn(error);
                        this.waitForLoader()
                        .then(() => this.resultContainer.innerHTML = this.errorTemplate())
                    }
                        
                    );
            });
        });
    }
}